import { Injectable } from '@angular/core';
import { jwtDecode, JwtPayload  } from 'jwt-decode';

@Injectable({
 providedIn: 'root'
})
export class JwtService {
 getGroupFromToken(token: string): string | null {
   try {
     const decoded: any = jwtDecode<JwtPayload>(token);
     return decoded?.groups || '';
   } catch (error) {
     console.error('Invalid token:', error);
     return null;
   }
 }
}